/* eslint-disable no-unused-vars */

export default async function addvolunteer(email, first, last, dob, address, phone, state, city, zipcode) {

    // require('dotenv').config()
   
    const Realm = require("realm-web"); 
    const REALM_ID = process.env.REACT_APP_PUBLIC_REALM_APP_ID;
    const REALM_KEY = process.env.REACT_APP_PUBLIC_REALM_APP_KEY;
    // console.log("Id", REALM_ID)
    // console.log("key", REALM_KEY)
    const app = new Realm.App({id: REALM_ID});
    const {
        // eslint-disable-next-line no-unused-vars
        BSON: { ObjectId },
    } = Realm;

  // Authenticate the user
    try {
        const credentials = Realm.Credentials.apiKey(REALM_KEY)
        await app.logIn(credentials);
        // console.log(user)
    } catch (error) {
        console.log("Error in Logging", error) 
    }

    try {
       
        // console.log("Sub id", currentuser.username)
    } catch (error) {
        console.log(error)
    }

  
    const mongo = app.currentUser.mongoClient("ehrcluster");
    const collection = mongo.db("ehrusers").collection("volunteers");
    
    try {

    const results = await collection.insertOne({

        "email": email,
        "first": first,
        "last": last,
        "dob": dob,
        "street_name": address,
        "state": state,
        "city": city,
        "zip_code": zipcode,
        "phone": phone,
        
    })

    // console.log(results)
    return results

    } catch (error) {

    console.log("Error from pulling Colletcion", error)  

    } 


  
}